export class CondicaoDePagamento {
  idCondPag: number;
  descricao: string;
  nParcelas: number;
  entrada: boolean;
  diasParcelas: number;
  codErp: string;
  taxaDA: number;
  status: number;
  valorMinimo: number;
  valorMaximo: number;
}
